import { deg2rad, rad2deg } from "@hscmap/angle";
import { sprintf } from "sprintf-js";
import { V3 } from '@/utils/math';
import { vec3 } from 'gl-matrix';

export function angle60html(a: number) {
  if (a < deg2rad(60 / 3600)) { // a < 1 arcmin
    const asec = (rad2deg(a) * 3600)
    return sprintf(`%06.4f&Prime;`, asec)
  }
  if (a < deg2rad(1)) { // a < 1 degree
    const amin = rad2deg(a) * 60
    return sprintf(`%06.4f&prime;`, amin)
  } else { // a >= 1 degree
    const deg = rad2deg(a)
    return sprintf(`%06.4f&deg;`, deg)
  }
}

export function angle(p: V3, q: V3) {
  const d = vec3.dist(p, q)
  return 2 * Math.asin(d / 2)
}
